<template>
  <v-app>
    <v-toolbar app>
      <router-link to="/">
      <v-toolbar-title class="headline text-uppercase">
        <span>Cardolini</span>
        <span class="font-weight-light"> Редактор цифрового контента </span>

      </v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
      <v-toolbar-title class="headline text-uppercase">
          <span > {{titleHead}} </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    <v-menu open-on-hover bottom offset-y

        v-for="(mnuItem, mi) in mnuTopData"
        :key="mi"
        
        >
      <v-btn
        flat
        slot="activator"
        color="primary"
        dark
        @click="goToPage(mnuItem.urlPage)"
        v-if="mnuItem.viewMnu"
      >
        <span class="mr-2">{{mnuItem.title}}</span>
      </v-btn>

      <v-list v-if="mnuItem.submenu">
        <v-list-tile
          v-for="(item, index) in mnuItem.submenu"
          :key="index"
          @click="goToPage(item.urlPage)"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>





<!--       <v-btn
        flat
        v-for="(mnuItem, mi) in mnuTopData"
        :key="mi"
        @click="goToPage(mnuItem.urlPage)"
      >
        <span class="mr-2">{{mnuItem.title}}</span>
      </v-btn> -->

    </v-toolbar>

    <v-content>
      <router-view/>
      <!-- <HelloWorld/> -->
    </v-content>
  <v-footer class="pa-3">
    <v-spacer></v-spacer>
    <div> &copy;  Cardolini - {{ new Date().getFullYear() }}</div>
  </v-footer>
  </v-app>
</template>

<script>
/* import HelloWorld from './components/HelloWorld' */
import axios from "axios";
import { mapState } from "vuex";
import router from "./router";
export default {
  name: 'App',
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Cardolini',
      // all titles will be injected into this template
      titleTemplate: '%s | My Awesome Webapp'
    },
  components: {
    //HelloWorld
  },
  data () {
    return {
      //
    }
  },  computed: {
    titleHead() {
      return this.$store.state.titleHead;
    },
    mnuTopData() {
      return this.$store.state.mnuTopData;
    },
  },
    mounted() {
    console.log("monted App = ", this);
    this.readData();
    console.log("store Data =", this.$store.state);
    this.$nextTick(
      function() {
        console.log(" ========================================== >> Cardolini Version 3.3 << =================================================== ");
      });


  },
  methods: {
      readData: function () {
        console.log("Read LocalStorage");
        let dataC = {ver: '4.0'}
        if(localStorage["dataCardolini"]){
          console.log("load from localStorage data = ", JSON.parse(localStorage.getItem("dataCardolini")));
        }
        else{
            localStorage["dataCardolini"] = JSON.stringify(dataC);
        }
              axios({
              method: "get",
              url: "js/data/mnuTop.json",
            })
              .catch(function(error) {
                // handle error
                console.log("ERROR: ", error);
              })
              .then(
                function(response) {
                  // handle success
                  console.log("mnuTopData =",response.data );
                  this.$store.commit("mnuTopData", response.data);
                  if (response.data === "0 results") {
                  } else {
                    console.log("All Data POSTS load from server");
                  }
                }.bind(this)
              );
              axios({
              method: "get",
              url: "js/data/homeData.json",
            })
              .catch(function(error) {
                // handle error
                console.log("ERROR: ", error);
              })
              .then(
                function(response) {
                  // handle success
                  console.log("homeData =",response.data );
                  this.$store.commit("homeData", response.data);
                  if (response.data === "0 results") {
                  } else {
                    console.log("All Data POSTS load from server");
                  }
                }.bind(this)
              );
/*
              axios({
              method: "post",
              url: "http://cardolini.ru/includes/gnf.php",
              data:{
                fpath:'../library/template/bg/'
                }
            })
              .catch(function(error) {
                // handle error
                console.log("ERROR: ", error);
              })
              .then(
                function(response) {
                  // handle success
                  console.log("response name Pictures =",response.data );
                  this.$store.commit("libBGTest", response.data);
                  if (response.data === "0 results") {
                  } else {
                    console.log("All Data POSTS load from server");
                  }
                }.bind(this)
              ); */
      },
      goToPage: function(namePage) {
                  router.push('/'+namePage);
                 // router.push(namePage);
                console.log("gotoPage page App = ", namePage);
      },
  },
}
</script>
<style>

a{
  text-decoration: none;
}
a .headline{
  color: #000000;
  
}
</style>
